import { Slot, createComponent, toClassName } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { App, Layout, Flex, Block, Container } = shared;

import { useSidebar } from '@/hooks/sidebar';
import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';
import MenuList from '@/components/MenuList';
import CategoryMenuList from '@/components/CategoryMenuList';
import { SidebarButtonCollapse, SidebarButtonExpand } from '@/components/SidebarButton';

import styles from './index.module.scss';

export default createComponent('GameLayout', { styles }, function GameLayout ({ mergeClassNames, slots }, props) {
  const {
    expand, 
    collapse, 
    sidebarState,
    mobileSidebarState
  } = useSidebar();

  const className = mergeClassNames(toClassName('GameLayout', {
    sidebarCollapsed: sidebarState.collapsed,
    mobileSidebarCollapsed: mobileSidebarState.collapsed
  }));

  return (
    <Layout className={className} fillScreen>
      <MenuList.Overlay className='GameLayout__MobileSidebar'>
        <Block>
          <SidebarButtonCollapse onClick={collapse}>
            Categories
          </SidebarButtonCollapse>
        </Block>
        <Block>
          <CategoryMenuList categories={props.categories} />
        </Block>
      </MenuList.Overlay>

      <App.Header>
        <AppHeader>
          <Slot name='mobile'>
            <SidebarButtonExpand onClick={expand} collapsed={!mobileSidebarState.collapsed} />
          </Slot>
          <Slot name='desktop'>
            <SidebarButtonExpand onClick={expand} collapsed={!sidebarState.collapsed} />
          </Slot>
        </AppHeader>
      </App.Header>

      <App.Main>
        <Flex wide tall>
          <Flex tag='aside' className='GameLayout__Sidebar'>
            <div>
              <Block>
                <SidebarButtonCollapse onClick={collapse}>
                  Categories
                </SidebarButtonCollapse>
              </Block>
              <Block>
                <CategoryMenuList categories={props.categories} />
              </Block>
            </div>
          </Flex>
          <Flex fit directionColumn className='GameLayout__Game'>
            {slots.game}
          </Flex>
          <Flex tag='aside' directionColumn className='GameLayout__Aside'>
            <div>
              <div>
                {slots.defaultSlot}
                <Block>
                  <AppFooter collapsed />
                </Block>
              </div>
            </div>
          </Flex>
        </Flex>
      </App.Main>
    </Layout>
  )
});
